<template>
  <swiper
      class="swiper-autoplay"
      :options="swiperOptions"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
  >
    <swiper-slide
        v-for="data in swiperData"
        :key="data.caminho_imagem"
        class="d-flex justify-content-center"
    >
      <b-img
          class="img-cover"
          :src="data.caminho_imagem"
          fluid
      />
    </swiper-slide>
    <div
        slot="pagination"
        class="swiper-pagination"
    />
    <div
        slot="button-next"
        class="swiper-button-next"
    />
    <div
        slot="button-prev"
        class="swiper-button-prev"
    />
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { BImg } from 'bootstrap-vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    swiperData: {
      get() {
        return this.value
      },
      set(swiper) {
        this.$emit('input', swiper)
      },
    },
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

    }
  },
}
</script>

<style lang="scss" scoped>
.img-cover {
  height: 100%;
  width: 30%;
  object-fit: cover;
}
</style>
